import React from 'react';
import classNames from 'classnames';
import { composeRef } from 'rc-util/lib/ref';
import warning from 'choerodon-ui/lib/_util/warning';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
const Typography = React.forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, component, className, 'aria-label': ariaLabel, setContentRef, children, ...restProps } = props;
    const { getProPrefixCls } = React.useContext(ConfigContext);
    let mergedRef = ref;
    if (setContentRef) {
        warning(false, `[c7n: Typography] setContentRef is deprecated. Please use ref instead.`);
        mergedRef = composeRef(ref, setContentRef);
    }
    const Component = component;
    const prefixCls = getProPrefixCls('typography', customizePrefixCls);
    const componentClassName = classNames(prefixCls, className);
    return (React.createElement(Component, Object.assign({ className: componentClassName, "aria-label": ariaLabel, ref: mergedRef }, restProps), children));
});
Typography.__PRO_TYPOGRAPHY = true;
Typography.displayName = 'Typography';
Typography.defaultProps = {
    component: 'article',
};
export default Typography;
